import axios from 'axios';

import Api from './Api';
import { Toast } from 'antd-mobile';

const axiosInstance = axios

axios.defaults.headers.common["token"] = localStorage.token;
// 添加响应拦截器
axiosInstance.interceptors.response.use(
    function (response) {
        // 对响应数据做些什么
        // 例如，可以对响应数据进行处理或转换
        if (response) {
            let { code, msg } = response.data;
            if (code && code !== 0) {
                Toast.show({
                    icon: 'fail',
                    content: msg,
                    duration: 2000,
                });
            }
            if (code === 401) {
                localStorage.removeItem("token")
                setTimeout(() => {
                    window.location.reload()
                }, 2000);
                return;
            }
        }
        return response;
    },
    function (error) {
        // 对响应错误做些什么
        if (error.status === 401) {
            localStorage.removeItem("token")
            setTimeout(() => {
                window.location.reload()
            }, 2000);
        }
        return Promise.reject(error);
    }
);
const get = async (url, params, config) => {
    try {
        if (!config) {
            config = {};
        }
        const response = await axiosInstance.get(Api.BASE_URL + url, { params: params, ...config });
        return response?.data ?? {};
    } catch (error) {
        throw error;
    }
};
const download = async (url, params, config) => {
    try {
        if (!config) {
            config = {};
        }
        const response = await axiosInstance.get(url, { params: params, ...config });
        return response?.data ?? {};
    } catch (error) {
        throw error;
    }
};
const post = async (url, body, params) => {
    try {
        const response = await axiosInstance.post(Api.BASE_URL + url, body, { params: params });
        return response?.data;
    } catch (error) {
        throw error;
    }
};

const put = async (url, body) => {
    try {
        const response = await axiosInstance.put(Api.BASE_URL + url, body);
        return response?.data;
    } catch (error) {
        throw error;
    }
};

const remove = async (url) => {
    try {
        const response = await axiosInstance.delete(Api.BASE_URL + url);
        return response?.data;
    } catch (error) {
        throw error;
    }
};

export { get, post, put, remove, download };